import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { CommonStoreService } from 'src/app/services/common-store.service';
import { ExpiredAppointmentService } from 'src/app/services/expired-appointment.service';

export const confirmationGuard: CanActivateFn = () => {
  const store = inject(CommonStoreService);
  const expiredService = inject(ExpiredAppointmentService);
  const router = inject(Router);

  // Check and reset if expired
  expiredService.checkAndResetBookingAppointmentIfExpired();

  // After possible reset, check if appointment exists
  const appointment = store.getBookedAppointmentSnapshot();
  if (appointment && appointment.createdAt) {
    return true;
  }
  return router.createUrlTree(['']);
};
